<template>
    <b-container fluid>
        <PortalNavbar show="true"></PortalNavbar>
        <section class="about_area row" >
  <div class="container">
   <!--<div class="tittle wow fadeInUp">
    <h2>ABOUT US</h2>
      
   </div>-->
   
   <div class="row about_row">
      
    <div class="who_we_area col-md-12 col-sm-6">
     <div class="subtittle">
      <h2 style="color:#ec5624;">Registration</h2>
     </div>
     

      <br> 
      <h2 class="text-primary">SECURITY GUARDS BOARD</h2>
      <br> 
      <div class="row">
        <div class="col">
         <ul style="margin-left:3%;">
           <li>Registration of Principal Employer</li>
           <li>Registration of Employer Agency</li>
           <li>Registration of existing and new Security Guards(Employee)</li>
         </ul>
        </div>
      </div>
      <br> 
      <p><strong>Registration of Principal Employer</strong>
      <button class="btn btn-default crc-drop-color1 crc-curve" style="width:150px;background-color: orange" type="button" id="dropdownMenu1" @click="signup('employer')">Register Now</button><br/><br/>
       (a) Every principal employer who engages registered Security Guards of the Board or Security Guards of employer agencies, whose Security Guards are granted exemption by the Government, in his establishment, shall get himself registered with the Board. by applying in the form devised by it:&nbsp;<br> <br>
       Provided that, principal employers who are already registered under the Existing scheme shall be deemed to be registered under this scheme.&nbsp;<br> <br>
       (b)The registered principal employers of the Board on appointed day shall continue to be principal employers of the Board and the employer agencies whose Security Guards are granted exemption. shall be strictly prohibited to provide their Security Guards to such principal employers.&nbsp;<br> <br>
       c) Every 2[Principal employer] who had engaged Private Security Guards before the commencement of the Maharashtra Private Security Guards (Regulation of Employment and Welfare) (Amendment) Scheme, 2005 shall get himself registered with the Board, by applying in the form devised by the Board, within Fifteen Days from the date of commencement of the said Scheme:&nbsp;<br> <br>
       Provided that, an employer of any establishment coming into existence after the commencement of the said Scheme shall apply for registration within a period of one month from the date of commencement of his business.&nbsp;<br> <br>
       Scheme 2002 , 13.(1)&nbsp;<br> <br>
       For detailed information, please click &amp; download&nbsp;<a href="http://securityguardsboard.in/images/pdf/ListofPrincipalemployers.pdf" target="_blank"><strong>List of the Registered Principle Employer</strong></a>
       
      </p>
    <br/>
   <p><strong>Registration of Employer Agency</strong>
   <button class="btn btn-default crc-drop-color1 crc-curve" style="width:150px;background-color: orange" type="button" id="dropdownMenu1" @click="signup('agency')">Register Now</button><br> <br>
   Every employer agency which has directly  employed private Security Guards or class or classes of Security Guards for  deployment to various establishments and 3[factories]to whose security guards,  the State Government has granted exemption, from operation of all or. any of  the provisions of the Act or Scheme by issuing notification under section 23 of  the Act, shall get itself registered with the Board within 15 days from the  date of publication of the exemption notification by applying in the form  devised by the Board, along with the number of Security Guards on its rolls.&nbsp;<br> <br>
   Scheme 2002 , 13.(2)&nbsp;<br> <br>
   For detailed information, please click &amp;  download&nbsp;<a href="http://securityguardsboard.in/images/pdf/LISTOFEXAMPTEDAGENCYES.pdf" target="_blank"><strong>List of  the Registered Exempted Agency</strong></a>
   
   </p>
    <br/>
   <p><strong>Employee Registration</strong>
   <!-- code comment 24-10-2024 -->
   <!-- <button class="btn btn-default crc-drop-color1 crc-curve" style="width:150px;background-color: orange" type="button" id="dropdownMenu1" @click="signup('pvtguard')">Register Now</button></p> -->
   <p><strong>Registration of existing and new Security Guards</strong><br> <br>
   (1)(a) Any person who desires to work as Security Guards shall, after following the procedure prescribed for selection as a Security Guard of the Board and on his selection as a Security Guard, apply for registration to the Board in the form devised by it. Provided that, Security Guards who are already registered under the existing scheme, shall be deemed to be registered under this scheme.&nbsp;<br> <br>
   (b) The qualifications for new registration shall be such as may be specified by the Board having regard to local conditions, physical fitness, capacity or experience. No person other than a citizen of India shall be eligible for registration, provided that a Gurkha who is a citizen of Nepal and was employed as Security Guard in the State of Maharashtra as on the appointed day shall be eligible for registration.&nbsp;<br> <br>
   (2) Notwithstanding any provision of this scheme, where the Board is of the opinion that a registered Security Guard of the Board has secured his registration by furnishing false information in his application or by with holding any information required therein or where it appears that a Security Guard has been registered improperly or incorrectly, the Board may direct the removal of his name from the register:&nbsp;<br> <br>
   Provided that, before giving any such direction, the Board shall give such Security Guard an opportunity of showing cause why the proposed direction should not be issued. Scheme 2002, 14(1)(2)&nbsp;<br> <br>
   A registration fee of rupees one hundred shall be paid to the Board by each Security Guard at the time of registration/enrollment under the Scheme. Scheme 2002, 17(1)&nbsp;
   </p>
   <br><br>
   <p><strong><em><u>Types of </u></em></strong><strong><em><u>Registration of existing and new Security Guards</u></em><br></strong>
    
    <br> <strong>1-<u>On compassionate Ground Procedure</u>-&nbsp; </strong><strong>The object of the Scheme is to grant appointment on compassionate grounds to a dependent family member of a Security Guard dying in harness "<em>Dependent Family Member</em>" means:</strong> <br> <strong>(a) spouse; or</strong><br> <strong>(b) son (including adopted son); or</strong><br> <strong>(c) daughter (including adopted daughter</strong> <strong>for details read <a href="http://securityguardsboard.in/images/pdf/RecruitmentGR-Anukampa-15July2009.pdf">GR. Dated 15 July 2009</a></strong><strong></strong></p><br>
   <p><strong>2-</strong><strong><u>After Court Orders</u></strong><strong>-Security Guards working with private security Agency in various establishment registered a case in court with Labour unions for registrations with Security Guard board in such a case after&nbsp; Court orders respective security guard registered in Board after checking proof his minimum 60 days working experience and&nbsp; qualifying Physical Measurement and Physical efficiency Test as per <a href="http://securityguardsboard.in/images/pdf/RecruitmentGR-2March2009.pdf"> GR 02 March 2009. for details read GR. Dated 02 March 2009.</a></strong></p><br>
   <p><strong>3-</strong><strong><u>Recommandation of Establishments</u></strong><strong>-After inspection Remarks of Security Guard Board Establishment recommends the Security Guards for registrations with Board after checking&nbsp; his Age ,Physical measurement and Physical efficiency Test registration procedure completes.</strong></p><br>
   <p><strong>4-</strong><strong><u>Experiences   Security Guards</u></strong><strong> as per GR dated 17 Oct 2013-</strong><strong> Any </strong><strong>Security Guards working with private security Agency who applied for&nbsp; registrations with Security Guard board respective security guard registered in Board after checking proof his minimum 60 days working experience and&nbsp; qualifying Physical Measurement and Physical efficiency Test</strong><strong>for details read   <a href="http://securityguardsboard.in/images/pdf/RecruitmentGR-17oct2013.pdf"> GR. Dated 17 Oct 2013</a></strong><strong></strong><br> <br> <br></p>
   <p><strong>Registration Fee</strong><br> <br>
   A registration fee of rupees one thousand shall be paid by each principal employer as well as employer agency at the time of registration under this Scheme. Scheme 2002, 17(2)&nbsp;<br> <br>
   For detailed information, please click &amp; download&nbsp;<br> <a href="http://securityguardsboard.in/images/pdf/ApplicationforPrincipalEmployerform-A.pdf" target="_blank"><strong>Principle Employer And Agency Registration Form (Form A)</strong></a>
   </p>
   <p><strong><u>Following Details are updated as on 1st April 2016</u></strong></p>
   <p><strong>Registration Chart</strong></p>
   <div class="row">
   <div class="col">
   <div class="table-responsive">
   <table class="table table-sm table-bordered">
      <tbody>
      <tr>
      <td>
      <p><strong>Sl No</strong></p>
      </td>
      <td>
      <p><strong>Particular</strong></p>
      </td>
      <td>
      <p><strong>No Of Registration</strong></p>
      </td>
      <td>
      <p><strong>Remarks</strong></p>
      </td>
      </tr>
      <tr>
      <td>
      <p><strong>1</strong></p>
      </td>
      <td>
      <p><strong>Principle Employers</strong></p>
      </td>
      <td>
      <p>3176</p>
      </td>
      <td>
      <p><strong><u><a href="http://securityguardsboard.in/images/pdf/ListofPrincipalemployers.pdf" target="_blank">View the List</a></u></strong></p>
      </td>
      </tr>
      <tr>
      <td>
      <p><strong>2</strong></p>
      </td>
      <td>
      <p><strong>Security Guards</strong></p>
      </td>
      <td>23600</td>
      <td>
      <p><strong>----</strong></p>
      </td>
      </tr>
      <tr>
      <td>
      <p><strong>3</strong></p>
      </td>
      <td>
      <p><strong>Exempted Agencies</strong></p>
      </td>
      <td>111</td>
      <td>
      <p><strong><u><a href="http://securityguardsboard.in/images/pdf/LISTOFEXAMPTEDAGENCYES.pdf" target="_blank">View the List</a></u></strong></p>
      </td>
      </tr>
      </tbody>
   </table>
   </div>
   </div>
   </div>

     
     
     
       
    </div>
    
     
   </div>
  </div>
 </section>

    </b-container>
</template>

<script>
import PortalNavbar from "@/components/PortalNavbar";
export default {
components: { PortalNavbar},
methods:{
    signup(typ){
        this.$router.push("/signup/"+typ);
    },
}
}
</script>

<style scoped>
.about_area .about_row {
  padding-top: 70px;
  padding-bottom: 70px;
}

.subtittle h2 {
  font: 700 36px "Open sans", sans-serif;
  color: #222222;
  text-transform: uppercase;
  position: relative;
  margin-bottom: 20px;
}
.subtittle h2:after {
  content: "";
  position: absolute;
  height: 2px;
  width: 120px;
  background: #222222;
  left: 0;
  bottom: -22px;
}
</style>



// WEBPACK FOOTER //
// src/components/Portal/Registration.vue